import React, { useEffect, useState } from 'react';

import { Box, Stack, TextField, Typography } from '@mui/material';

import { PopUp } from 'components/PopUp';

import { PopUpButtonProps } from 'types';

interface ImageInputPopUpProps {
  isOpen: boolean;
  close: () => void;
  onSubmit: (url: string) => void;
  initialUrl?: string;
  initialWidth?: string;
  initialHeight?: string;
  title?: string;
  urlReadOnly?: boolean;
}

export const ImageInputPopUp = ({
  isOpen,
  close,
  onSubmit,
  initialUrl = '',
  initialWidth = '400',
  initialHeight = '200',
  title = 'Add Image',
  urlReadOnly = false,
}: ImageInputPopUpProps) => {
  const [url, setUrl] = useState(initialUrl);

  // Update state when props change
  useEffect(() => {
    if (isOpen) {
      setUrl(initialUrl);
    }
  }, [isOpen, initialUrl, initialWidth, initialHeight]);

  const handleSubmit = () => {
    onSubmit(url);
    close();
  };

  const resetForm = () => {
    if (!urlReadOnly) {
      setUrl(initialUrl);
    }
  };

  const buttons: PopUpButtonProps[] = [
    {
      name: 'CANCEL',
      handler: () => {
        resetForm();
        close();
      },
      variant: 'outlined',
    },
    {
      name: 'SUBMIT',
      handler: handleSubmit,
      variant: 'contained',
    },
  ];

  return (
    <PopUp
      isPopUpOpen={isOpen}
      title={title}
      buttons={buttons}
      close={() => {
        resetForm();
        close();
      }}
      maxWidth="sm"
      fullWidth
      disableCTA={!url.trim()}
    >
      <Stack direction="column" spacing={2} width="100%">
        <TextField
          label="Image URL"
          fullWidth
          required
          value={url}
          onChange={(e) => setUrl(e.target.value)}
          placeholder="Enter image URL"
          disabled={urlReadOnly}
        />
        <Box>
          <Typography
            variant="body1"
            fontSize={'12px'}
            color={'grey.600'}
            sx={{ marginBottom: '12px' }}
          >
            * copy an image&apos;s url from the IMAGES tab and paste it here to include a new image.
          </Typography>
        </Box>
      </Stack>
    </PopUp>
  );
};
